import styled from 'styled-components';
import { KeywordsStyled } from '../KeywordsStyled';
import { rem } from 'polished';

export const KeywordsStyledAC = styled(KeywordsStyled)`
    margin-left: ${rem(10)};
    margin-right: ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;
